export const parseBooleanQueryParam = (param: string): boolean => {
  if (param === 'true' || param === 'false') {
    return Boolean(JSON.parse(param))
  } else {
    return false;
  }
};
